import { createAction } from 'utils/redux'

export const receiveCutoverNamespace = createAction('RECEIVE_CUTOVER_NAMESPACE')
